<template>
  <div class="deactivate-dialog">
    <h4 class="dialog-title warning">
      <i class="fal fa-exclamation-triangle"></i>
      ຢືນຢັນການປິດໃຊ້ງານ
    </h4>

    <div class="warning-content">
      <div class="warning-icon">
        <i class="fal fa-power-off"></i>
      </div>
      <div class="warning-text">
        <p>
          ທ່ານຕ້ອງການປິດໃຊ້ງານໂຫມດການຄວບຄຸມ ລະບົບການຄັດແຍກສຳລັບເຄື່ອງ
          <strong>{{ machineCode }}</strong> ບໍ?
        </p>
        <p class="warning-note">
          <i class="fal fa-info-circle"></i>
          ເມື່ອປິດໃຊ້ງານໂຫມດການຄວບຄຸມ, ເຄື່ອງຈະປະຄັດແຍກພັດສະດຸແບບປົກກະຕິ
        </p>
      </div>
    </div>

    <div class="dialog-actions">
      <vs-button flat @click="$emit('close')">ຍົກເລີກ</vs-button>
      <vs-button danger flat @click="confirmDeactivate()" :loading="isLoading">
        <i class="fal fa-power-off" style="margin-right: 5px"></i> ຢືນຢັນປິດໃຊ້ງານ
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeactivateConfirmDialog",

  props: {
    machineCode: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    confirmDeactivate() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
.deactivate-dialog {
  padding: 10px;
}

.dialog-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;

  &.warning {
    color: #ff9800;
  }

  i {
    margin-right: 8px;
  }
}

.warning-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  background: #fff3e0;
  border-radius: 10px;
  border-left: 4px solid #ff9800;
}

.warning-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffecb3;
  border-radius: 50%;

  i {
    font-size: 28px;
    color: #ff9800;
  }
}

.warning-text {
  flex: 1;

  p {
    margin: 0 0 10px 0;
    color: #333;

    strong {
      color: #195bff;
    }
  }

  .warning-note {
    font-size: 13px;
    color: #666;
    padding: 10px;
    background: white;
    border-radius: 5px;

    i {
      margin-right: 5px;
      color: #ff9800;
    }
  }
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}
</style>
